export default __webpack_public_path__ + "static/media/logout.b60992da.svg";